/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../../common/model.class';
import * as moment from 'moment';
import Moment = moment.Moment;

export class ProfessionalLicense extends ModelMixin() implements Model<ProfessionalLicense> {

    TYPE = ProfessionalLicense;

    stateLicenseNumber?: string;
    state?: string;
    dateIssued?: Moment;
    expirationDate?: Moment;

    needsControlSubstancePermit?: boolean;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.dateIssued) jsonData.dateIssued = moment(jsonData.dateIssued);
        if (jsonData.expirationDate) jsonData.expirationDate = moment(jsonData.expirationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/professional/professional-license.model.ts